// @ts-nocheck
import { API } from '../api/api'
import localStorageService from '../api/localStorageService'
import { DATETIMEFORMATWITHCONSTANT, MESSAGE_SEVERITIES } from '../helpers/constants'
import { formatDate, isEmpty, isNullOrEmpty } from '../helpers/utils'
import { fetch, post, put } from './../api/httpClient'
import { messageAction } from './app.action'

export const getMySurveyCall = (successCallback, failureCallback) => async (dispatch) => {
  try {
    const { data } = await fetch(`${API.SURVEY.SURVEY_USER_DATA}/all-surveys`)
    const updatedData = data
      .filter((survey) => !survey.is_survey_filled)
      .map((item) => modifySurveyList(item))
    if (typeof successCallback === 'function') {
      successCallback(updatedData)
      localStorageService.setMySurveyCount(updatedData.length)
    }
  } catch (error) {
    dispatch(
      messageAction({
        subTitle: 'message:getSurveyFailed',
        severity: MESSAGE_SEVERITIES.ERROR,
      })
    )

    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const fetchPublicSurveyDetailCall = (id, successCallback, failureCallback) => async () => {
  try {
    const apiPath = `${API.SURVEY.PUBLIC_SURVEY}/${id || ''}`
    const { data } = await fetch(apiPath, {})
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const fetchSurveyDetailCall = (id, successCallback, failureCallback) => async () => {
  try {
    const apiPath = `${API.SURVEY.SURVEY_DETAIL}/${id || ''}`
    const { data } = await fetch(apiPath, {})
    const modifiedData = modifySurveyDetails(data)
    if (typeof successCallback === 'function') {
      successCallback(modifiedData)
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const submitSurveyDataCall = (payload, successCallback, failureCallback) => async () => {
  try {
    await post(API.SURVEY.SURVEY_USER_DATA, payload)
    if (typeof successCallback === 'function') {
      successCallback()
    }
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}

export const submitPublicSurveyDataCall =
  (payload, successCallback, failureCallback) => async (dispatch) => {
    try {
      await post(API.SURVEY.PUBLIC_SURVEY_USER_DATA, payload)
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (err) {
      dispatch(
        messageAction({
          subTitle: 'message:surveySubmmisionFailed',
          severity: MESSAGE_SEVERITIES.ERROR,
        })
      )
      if (typeof failureCallback === 'function') {
        failureCallback(err)
      }
    }
  }

export const getSurveyConfig = (payload, successCallback, failureCallback) => async (dispatch) => {
  try {
    const { survey_type_ids } = payload
    if (isNullOrEmpty(survey_type_ids)) {
      return
    }
    const updatedPayload = {
      sc_details: survey_type_ids,
    }

    const { data } = await put(API.SURVEY.SURVEY_CONFIG, updatedPayload)
    const modifiedData = data
      .filter((survey) => !survey.is_survey_filled)
      .map((item) => modifySurveyList(item))

    const { mandatoryData, optionalData } = modifiedData.reduce(
      (acc, survey) => {
        acc[survey.sr_type === 'Mandatory' ? 'mandatoryData' : 'optionalData'].push(survey)
        return acc
      },
      { mandatoryData: [], optionalData: [] }
    )

    const updatedData = [...mandatoryData, ...optionalData]

    if (typeof successCallback === 'function') {
      successCallback(updatedData)
    }
  } catch (error) {
    dispatch(
      messageAction({
        subTitle: 'message:getSurveyFailed',
        severity: MESSAGE_SEVERITIES.ERROR,
      })
    )

    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

const modifySurveyDetails = (item) => {
  if (isEmpty(item)) {
    return
  }
  return {
    sr_content: item.sr_content,
    sr_title: item.sr_title,
    sr_description: item?.sr_description,
    _id: item._id,
    sr_description: item.sr_description,
    sr_config_id: item.sr_config_id,
  }
}

const modifySurveyList = (item) => {
  if (isEmpty(item)) {
    return
  }
  return {
    ...item,
    sr_content: item.survey_content?.sd_content,
    sr_title: item?.survey_details?.sr_title,
    sr_description: item?.survey_details?.sr_description,
    _id: item.survey_id,
    sr_endDate: formatDate(item?.survey_details?.sr_end_date, DATETIMEFORMATWITHCONSTANT),
    sr_description: item?.survey_details?.sr_description,
    sr_config_id: item?.sr_config_id,
    aliasName: item.program_name || item.course_name,
    sr_type: item?.survey_details?.sr_type,
    sr_is_anonymous: item?.survey_details?.sr_is_anonymous,
    sr_sch_name: item?.survey_details?.sr_sch_name,
  }
}
